/**
 * Protected Route Component
 * 
 * A wrapper component that checks for authentication before
 * rendering the child components. If no JWT token is found in
 * sessionStorage, redirects to the login page.
 * 
 * Usage:
 * <ProtectedRoute>
 *   <YourProtectedComponent />
 * </ProtectedRoute>
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../services/api';

const ProtectedRoute = ({ children }) => {
  // Check if JWT token exists and has not expired
  if (!isTokenValid()) {
    return <Navigate to="/login" replace />;
  }
  
  // Token is valid, render children
  return children;
};

export default ProtectedRoute;
